import { DEFAULT_MASCOT, JAGUAR_DEFAULTS, type MascotConfig } from './mascot-catalog'
import type { MascotGamePayload } from './game/mascot-game-types'

export function isSheepAvailable(catalog?: MascotGamePayload['catalog']): boolean {
  return (
    catalog?.mascot_available === true &&
    catalog.mascot_species?.includes('sheep') === true
  )
}

export function campaignMascotSpecies(institutionId?: number): 'jaguar' | undefined {
  return institutionId === 6 ? 'jaguar' : undefined
}

export function withRequiredMascotSpecies(
  config: MascotConfig | null,
  requiredSpecies?: 'jaguar' | null
): MascotConfig | null {
  if (!requiredSpecies) return config
  const next = { ...(config ?? DEFAULT_MASCOT) }
  if (next.species !== 'jaguar') {
    next.color = 'honey'
    delete next.furColor
    delete next.sceneColor
  }
  if (next.species === 'sheep') {
    next.accessory = 'bandana'
    next.headwear = 'none'
    next.toy = 'none'
    delete next.eyeColor
    delete next.accessoryColor
    delete next.headwearColor
  }
  return { ...next, ...JAGUAR_DEFAULTS, color: next.color }
}

// Available immediately on entry; the API also covers other campaigns of this institution.
export function campaignMascotBackdrop(
  campaignId: number,
  requiredBackdrop?: MascotConfig['backdrop'] | null
): MascotConfig['backdrop'] | undefined {
  return campaignId === 65 ? 'farm' : (requiredBackdrop ?? undefined)
}

export function withMascotBackdrop(
  config: MascotConfig,
  requiredBackdrop?: MascotConfig['backdrop']
): MascotConfig {
  return requiredBackdrop ? { ...config, backdrop: requiredBackdrop } : config
}
